export default __webpack_public_path__ + "static/media/group-option-hair-selected.74e4557f.svg";